import React from 'react';
import {connect} from "react-redux";
import Popup from "../../../parts/Popup";
import CommonTab from "../../../parts/CommonTabClass";

class TenderTypesPublicationUnitTypeComponent extends CommonTab {
    state = {
        tenderPublicationUnitType: this.props.tenderPublicationUnitType,
        errors: [],
        validateFields: [
            'tenderpublicationunittypename',
            'tenderpublicationunittypenameeng'
        ]
    };

    changeState(name, e) {
        let temp = this.state.tenderPublicationUnitType;
        temp[name] = e.value;
        this.setState({tenderPublicationUnitType: temp});
    }

    render() {
        let {tenderPublicationUnitType, errors, validateFields} = this.state;
        let {close} = this.props;
        return (
            <Popup openClose={close}>
                <div className={'popup-content-types'}>
                    <form onSubmit={event => {
                        event.preventDefault();
                        this.formValidation(tenderPublicationUnitType, validateFields);
                    }}>
                        <h2>{this.props.button} Tender Publication Unit Type</h2>
                        <table className={'table table-striped'} align={'right'}>
                            <tbody>
                            <tr>
                                <td>Tender Publication Unit Type Name :</td>
                                <td className={errors.indexOf('tenderpublicationunittypename') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationUnitType.tenderpublicationunittypename}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationunittypename', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationunittypename') !== -1 ? <span className="errorText">Please set Unit Type Name</span> : '' }
                                </td>
                            </tr>
                            <tr>
                                <td>Tender Publication Unit Type Nameeng :</td>
                                <td className={errors.indexOf('tenderpublicationunittypenameeng') !== -1 ? 'error' : ''}>
                                    <input
                                        type={'text'}
                                        value={tenderPublicationUnitType.tenderpublicationunittypenameeng}
                                        onChange={(e) => {
                                            this.changeState('tenderpublicationunittypenameeng', e.target);
                                        }}
                                    />
                                    {errors.indexOf('tenderpublicationunittypenameeng') !== -1 ? <span className="errorText">Please set Unit Type Name Eng</span> : '' }
                                </td>
                            </tr>
                            </tbody>
                        </table>
                        <input type={"submit"} className={"btn btn-primary"} value={this.props.button}/>
                    </form>
                </div>
            </Popup>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    let content = {};
    state.tenderPublicationUnits.map((item) => {
        if (item.tenderpublicationunittypeid == ownProps.id) {
            content = item;
        }
    });
    return {
        tenderPublicationUnitType: Object.assign({}, content)
    }
};

const TenderTypesPublicationUnitType = connect(mapStateToProps)(TenderTypesPublicationUnitTypeComponent);

export default TenderTypesPublicationUnitType;